import styled from "styled-components";

import { NowFilterPlaceholderStyledProps as Props } from "./NowFilterPlaceholder.types";
import CONSTANTS from "config/constants";

const { mobile, desktop, tablet } = CONSTANTS.BREAKPOINTS;

const NowFilterPlaceholderStyled = styled.div<Props>`
  display: flex;
  flex: 1;
  justify-content: space-between;

  @media (max-width: ${tablet - 1}px) {
    flex-direction: column;
  }

  .NowFilterPlaceholder {
    &__card {
      margin-top: -12rem;

      @media (max-width: ${tablet - 1}px) {
        width: fit-content;
      }
    }

    &__movie {
      width: 100%;
      padding-left: 3.2rem;
      min-height: 28rem;

      @media (max-width: ${tablet - 1}px) {
        padding-left: 0;
        padding-top: 4rem;
      }
    }

    &__image {
      height: 28rem;
      border-radius: 0.4rem;
      min-width: 18rem;
    }

    &__modality {
      width: 9.6rem;
      height: 2.4rem;
      margin-top: 1.6rem;
      border-radius: 0.8rem;
    }

    &__theater {
      width: 20rem;
      height: 2.4rem;
      margin-top: 1.6rem;
      margin-bottom: 2.4rem;
      border-radius: 0.8rem;
    }

    &__language {
      width: 6.4rem;
      margin-top: 0.8rem;
      height: 1.6rem;
      border-radius: 0.8rem;
    }

    &__title {
      margin: 0.4rem 0;
      height: 2rem;
      border-radius: 0.8rem;
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: ${tablet - 1}px) {
        flex-direction: column;
        align-items: flex-start;
      }

      &__header {
        width: 80%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        @media (max-width: ${desktop}px) {
          width: 88%;

          & > :not(:nth-last-child(-n + 3)) {
            display: none;
          }
        }

        @media (max-width: ${tablet}px) {
          width: 100%;
        }
      }
    }

    &__subtitle {
      height: 2rem;
      border-radius: 0.8rem;
      width: 32%;

      @media (max-width: ${tablet - 1}px) {
        width: 100%;
        margin-bottom: 1.6rem;
      }
    }

    &__button {
      width: 12.8rem;
      height: 3.8rem;
      border-radius: 0.8rem;

      @media (max-width: ${desktop}px) {
        width: 12rem;
      }

      @media (max-width: ${tablet - 1}px) {
        width: 10rem;
      }

      @media (max-width: ${mobile}px) {
        width: 8rem;
      }
    }

    &__line {
      width: 100%;
      margin-top: 1.6rem;
      margin-bottom: 2rem;
      height: 0.2rem;
    }
  }
`;

export default NowFilterPlaceholderStyled;
